import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class PlayerGroupingsSwitch extends Component {
    onClick() {
        const {playerGroupingsSwitch} = this.props;

        this.props.dispatch(Action.do('switchPlayerGroupings', !playerGroupingsSwitch.isOn()));
    }

    render() {
        const {playerGroupingsSwitch, openGroupingsLabel = ''} = this.props;

        return (
            <div className={`advanced-filter${playerGroupingsSwitch.isOn() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={this.onClick.bind(this)}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Close Groupings Options
                    </button>
                    <button
                        type="button"
                        onClick={this.onClick.bind(this)}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>{openGroupingsLabel || 'Player Groupings'}
                    </button>
                </div>
                {playerGroupingsSwitch.isOn() ? this.props.children : null}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    return {
        playerGroupingsSwitch: state.playerGroupingsSwitch,
    };
}

export default connect(mapStatesToProps)(PlayerGroupingsSwitch);
